module.exports = __webpack_public_path__ + "static/img/bd.9a6cf432.svg";